import { ParametersWithTitle } from "./ParametersWithTitle";

import { ModelAndProviderPreview } from "./ModelAndProviderPreview";
import { useParameters } from "../../store/parameters-store";
import { observer } from "mobx-react-lite";
import { useModelsStore } from "@/providers/ProviderAndModelsProvider/models-store";
import LoadingSpinner from "@/components/LoadingSpinner";

export const ModelPreviewContent = observer(
  ({ showGeneralInformation }: { showGeneralInformation: boolean }) => {
    const { parameters, promptData } = useParameters();
    const { store: modelsStore } = useModelsStore({});
    const { modelsLoading } = modelsStore;

    if (modelsLoading) {
      return (
        <div className="my-8 flex h-full w-full items-center justify-center">
          <LoadingSpinner size={8} />
        </div>
      );
    }

    const modelName =
      promptData?.metadata?.model?.name ||
      promptData?.inference_client_name ||
      "";

    return modelName ? (
      <div
        className="max-h-[53vh] overflow-y-auto"
        style={{ scrollbarGutter: "stable" }}
      >
        <div className="w-full pb-2">
          {showGeneralInformation && (
            <ModelAndProviderPreview promptData={promptData} />
          )}
          <ParametersWithTitle parameters={parameters || []} />
        </div>
      </div>
    ) : (
      <p className="text-sm italic text-gray-400">
        No parameters set for this prompt version
      </p>
    );
  },
);
